import { createPatch } from './create-patch';
export function createStateOptimizer({ store, onChange, disablePatching, }) {
    let patchNumber = 0;
    let prevState = store.getState();
    const listener = () => {
        const nextState = store.getState();
        if (nextState === prevState) {
            return;
        }
        if (disablePatching) {
            onChange({ type: 'SET', state: store.getState() });
            return;
        }
        patchNumber++;
        const patch = createPatch(prevState, nextState);
        onChange({ type: 'PATCH', patchNumber, patch });
        prevState = nextState;
    };
    return {
        subscribe: () => store.subscribe(listener),
        requestFullState: () => {
            patchNumber = 0;
            onChange({ type: 'SET', state: store.getState() });
        },
    };
}
//# sourceMappingURL=state-optimizer.js.map